// removed by extract-text-webpack-plugin
module.exports = {"MainWrapper":"src-layouts----index-module---MainWrapper---3oihu"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/index.module.css
// module id = 358
// module chunks = 114276838955818